import React from 'react';
import { Hidden, LinearProgress } from '@belong/ui-core';
import { Column, Columns } from '../../ui';
import { Copy } from '../../styles/Typography';
import { SteppedProgressBar } from './Carousel.styles';

export const CarouselProgress = ({ progressWidth, currentSlide, totalSlides }) => {
  return (
    <SteppedProgressBar>
      <Hidden atAndAbove="md">
        <Columns space="small" alignY="center">
          <Column width="flex">
            <LinearProgress borderRadius isThin completed={progressWidth} stepPosition={currentSlide} />
          </Column>
          <Column width="content">
            <Copy variant="small">
              {currentSlide + 1} of {totalSlides}
            </Copy>
          </Column>
        </Columns>
      </Hidden>

      <Hidden below="md">
        <Columns space="small" alignY="center">
          <Column width="flex">
            <LinearProgress
              borderRadius
              isThin
              completed={progressWidth}
              stepPosition={currentSlide === totalSlides - 1 ? currentSlide - 1 : currentSlide}
            />
          </Column>
        </Columns>
      </Hidden>
    </SteppedProgressBar>
  );
};

CarouselProgress.displayName = 'CarouselProgress';
